export const LOGIN = "[Login] User login";
